import { AvatarImage } from "@/assets/images";
import { User } from "lucide-react";
import { cn } from "@/utils/cn";
import { useTranslation } from "react-i18next";

type IProps = {
  imageSrc: string;
  isOnline?: boolean;
  className?: string;
  wrapperClassName?: string;
};

export const Avatar = ({
  imageSrc,
  isOnline = false,
  className,
  wrapperClassName,
}: IProps) => {
  const { t } = useTranslation(["common"]);
  return (
    <div className={cn("flex items-center gap-2 relative", className)}>
      <div
        className={cn(
          "size-10 bg-info-muted rounded-xs overflow-hidden",
          wrapperClassName
        )}
      >
        {imageSrc ? (
          <img
            alt={t("common:header.profile")}
            src={imageSrc?.trim() || AvatarImage}
            className="object-cover size-full"
          />
        ) : (
          <div className="flex justify-center items-center w-full h-full">
            <User size={20} className="text-primary" />
          </div>
        )}
      </div>
      {isOnline && (
        <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-success rounded-full" />
      )}
    </div>
  );
};
